export const GO_SHOW_SET_BOOKING_FORM = 'BUS/GO_SHOW_SET_BOOKING_FORM';

export default function setBookingForm(key, value) {
  return {
    type: GO_SHOW_SET_BOOKING_FORM,
    key,
    value,
  };
}
